<!--
 * @Author: cmchiu
 * @Date: 2023-01-03 16:36:40
 * @LastEditTime: 2023-01-11 17:01:02
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \LearningMarket2\LearningMarket-ClientApp\src\components\Breadcrumb\breadcrumb.vue
 * 
-->
<template>
    <div class="breadcrumb">
        <div class="row">
            <div class="col-lg-12 mt-20">
                <el-breadcrumb separator="»">
                    <el-breadcrumb-item>
                        <a :href="campusBaseUrl"> <img :src="`${baseUrl}assets/images/home.png`" alt="" />首頁 </a>
                    </el-breadcrumb-item>
                    <el-breadcrumb-item v-for="(item, index) in levelLs" :key="item.path">
                        <span
                            v-if="item.redirect === 'noRedirect' || index == levelLs.length - 1"
                            class="no-redirect"
                            >{{
                                ['PostNews', 'CourseBook'].includes(item.name)
                                    ? $store.getters.pnTitle || item.meta.title
                                    : item.meta.title
                            }}</span
                        >
                        <a v-else @click.prevent="handleLink(item)"> {{ item.meta.title }}</a>
                    </el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
    </div>
</template>

<script>
import { compile } from 'path-to-regexp'

export default {
    name: 'breadcrumb',

    data: function () {
        return {
            baseUrl: process.env.BASE_URL,
            campusBaseUrl: process.env.VUE_APP_CampusURL,
            levelLs: [],
        }
    },

    created: function () {
        this.getBreadcrumb()
    },

    watch: {
        $route() {
            this.getBreadcrumb()
        },
    },

    methods: {
        getBreadcrumb() {
            // only show routes with meta.title
            let matched = this.$route.matched.filter(item => item.meta && item.meta.title)
            const first = matched[0]

            if (!this.isDashboard(first)) {
                matched = [{ path: '/courselist', meta: { title: '學習市集' } }].concat(matched)
            }

            this.levelLs = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false)
        },
        isDashboard(route) {
            const name = route && route.name
            if (!name) {
                return false
            }
            return name.trim().toLocaleLowerCase() === 'CourseList'.toLocaleLowerCase()
        },
        handleLink(item) {
            const { redirect, path } = item
            if (redirect) {
                this.$store.dispatch('app/cachePNTitle', '')
                this.$router.push(redirect)
                return
            }
            this.$router.push(this.pathCompile(path))
        },
        pathCompile(path) {
            const { params } = this.$route
            var toPath = compile(path)
            return toPath(params)
        },

        goHome() {
            window.location.href = process.env.VUE_APP_CampusURL
        },
    },
}
</script>

<style scoped lang="scss">
.breadcrumb {
    margin-bottom: 16px;

    img {
        width: 14px;
    }

    a {
        color: #2d9698;
    }

    ::v-deep .el-breadcrumb__separator {
        color: unset;
        margin: 0 0.5rem;
    }
}
</style>
